// extracted by mini-css-extract-plugin
export default {"sectionWrap":"SortingAndCountingSection_sectionWrap__j+sLU"};